import React, { useState, useEffect } from "react";
import { notificationService } from "../services/notification.service";

const NotificationsPage = () => {
  const notifications = [
    { id: 1, title: "New user registered", time: "2m", read: false },
    { id: 2, title: "Server restarted successfully", time: "10m", read: true },
    { id: 3, title: "Invoice #INV-1032 paid", time: "1h", read: false },
    { id: 4, title: "New order received", time: "2h", read: true },
    { id: 5, title: "Backup completed", time: "3h", read: true },
    { id: 6, title: "Password updated", time: "5h", read: true },
    { id: 7, title: "User Alfred logged in", time: "6h", read: false },
    { id: 8, title: "Subscription renewed", time: "7h", read: true },
    { id: 9, title: "Payment failed for INV-204", time: "9h", read: false },
    { id: 10, title: "Database optimized", time: "11h", read: true },
    { id: 11, title: "New message received", time: "12h", read: false },
    { id: 12, title: "Report generated", time: "14h", read: true },
    { id: 13, title: "System update installed", time: "15h", read: true },
    { id: 14, title: "API key created", time: "16h", read: false },
  ];

  const ITEMS_PER_PAGE = 10;

  const [page, setPage] = useState(1);

  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const visibleNotifications = notifications.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const totalPages = Math.ceil(notifications.length / ITEMS_PER_PAGE);


  useEffect(() => {
    notificationService.genenralNotificationList().then((res)=> {
      console.log('list..... ',res.data );
    }).catch((err)=> {
      console.log('error..... ',err );
    });
  }, []);

  // const getGeneralNotificationList = async () => {
  //   try {
  //     const response = await notificationService.genenralNotificationList();
  //     console.log('List ', response.data);
  //   } catch (error) {
  //     console.error("Error fetching notifications:", error);
  //   }
  // };

  return (
    <div className="max-w-3xl mx-auto p-4">

      {/* Header */}
      <div className="mb-3 flex justify-between items-center">
        <h1 className="text-lg font-semibold">Notifications</h1>
        <span className="text-xs text-gray-500">
          Page {page} of {totalPages}
        </span>
      </div>

      {/* Notifications List */}
      <div className="bg-white border rounded-md">

        {visibleNotifications.map((n) => (
          <div
            key={n.id}
            className={`flex items-center justify-between px-3 py-2 text-sm border-b last:border-none hover:bg-gray-50 ${
              !n.read ? "bg-blue-50" : ""
            }`}
          >
            <div className="flex items-center gap-2">

              {!n.read && (
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
              )}

              <span className={`${!n.read ? "font-medium" : "text-gray-700"}`}>
                {n.title}
              </span>

            </div>

            <span className="text-xs text-gray-400">{n.time}</span>
          </div>
        ))}

      </div>

      {/* Pagination */}
      <div className="flex justify-between mt-3">

        <button
          onClick={() => setPage(page - 1)}
          disabled={page === 1}
          className="px-3 py-1 text-sm border rounded disabled:opacity-40"
        >
          Previous
        </button>

        <button
          onClick={() => setPage(page + 1)}
          disabled={page === totalPages}
          className="px-3 py-1 text-sm border rounded disabled:opacity-40"
        >
          Next
        </button>

      </div>
    </div>
  );
};

export default NotificationsPage;